import { InputLabel } from "@mui/material";
import MDBox from "components/MDBox";
import MDSelect from "components/MDSelect";
import { useEffect, useState } from "react";
import { get } from "utils/WebService";


export default function MDCompanySelect({
    value,
    handleChange,
    placeholder,
    isMulti = false,
    name,
    label,
    onlyOneCompany }) {

    const [isLoadingCompanies, setIsLoadingCompanies] = useState(true);
    const [companiesOptions, setCompaniesOptions] = useState([]);

    useEffect(() => {
        get("/pessoa/list-all")
            .then(({ list }) => {
                setCompaniesOptions(list);
                setIsLoadingCompanies(false);
            }).catch(() => {
                setCompaniesOptions([]);
                setIsLoadingCompanies(false);
            });
    }, []);

    useEffect(() => {
        if (companiesOptions?.length === 1) {
            onlyOneCompany(companiesOptions[0])
        }
    }, [companiesOptions]);

    return (
        <MDBox>
            <InputLabel sx={{ px: 1, pb: 0.5 }}>{label}</InputLabel>
            <MDSelect
                name={name}
                options={companiesOptions?.sort((a, b) => (a.nomeComum || '').localeCompare(b.nomeComum || ''))}
                value={(companiesOptions?.length === 1 && !isMulti) ? companiesOptions[0] : value}
                onChange={handleChange}
                isLoading={isLoadingCompanies}
                placeholder={placeholder}
                getOptionLabel={(option) => option.nomeComum || option.nomeCompleto}
                getOptionValue={(option) => option.id}
                isMulti={isMulti}
            />
        </MDBox>
    );
}
